// Copyright (C) Lembani Sakala - All rights reserved.
// Lembani Sakala.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { getUserAsync } from '../../../app/user/userSlice';
import jwtDecode from 'jwt-decode';
import { IDecodedUser } from '../../../interfaces/user';
import { getToken } from '../../../utils/localStorage';
import { formatDateTime } from '../../../utils/datetimeFomatter';
import { ClipLoader } from 'react-spinners';
import {
  FaCar,
  FaMapMarkerAlt,
  FaCalendarAlt,
  FaUserFriends,
  FaUser,
  FaEnvelope,
  FaPhone,
  FaArrowLeft,
  FaCreditCard,
} from 'react-icons/fa';

export const RentalDetails = () => {
  const { id } = useParams();
  const { userInfo } = useAppSelector((state) => state.user);

  const dispatch = useAppDispatch();

  const tk = getToken();
  let d: IDecodedUser;
  let uid = 0;
  if (tk !== null) {
    d = jwtDecode(tk);
    uid = d.sub;
  }

  const booking = userInfo?.bookings.find((rental: any) => rental.id === Number(id));

  let currency = '';
  if (booking?.selectedRate === 'ZMW') {
    currency = 'K';
  } else if (booking?.selectedRate === 'USD') {
    currency = '$';
  }

  useEffect(() => {
    dispatch(getUserAsync(uid));
  }, [dispatch, uid]);

  if (!booking) {
    return (
      <div className='col-md-5 text-center mx-auto py-4'>
        <ClipLoader color='#e81f29' size={50} />
      </div>
    );
  }

  const startDateTime = new Date(booking.startDate);
  const endDateTime = new Date(booking.endDate);
  const { formattedDate: startDate, formattedTime: startTime } = formatDateTime(startDateTime);
  const { formattedDate: endDate, formattedTime: endTime } = formatDateTime(endDateTime);

  return (
    <>
      <Link to='/dashboard/rentals' className='quote-btn quote-btn-secondary mb-3'>
        <FaArrowLeft className='me-1' /> Back to Bookings
      </Link>

      <div className='quote-card' style={{ marginBottom: '20px' }}>
        <div className='quote-card-title' style={{ justifyContent: 'space-between' }}>
          <span><FaCar /> Booking #{booking.bookingNumber}</span>
          {booking.status === 'Pending Confirmation' ? (
            <span className='history-badge history-badge-info'>{booking.status}</span>
          ) : (
            <span className='history-badge history-badge-success'>{booking.status}</span>
          )}
        </div>

        <div className='quote-info-grid' style={{ marginBottom: 0 }}>
          <div>
            <h5 style={{ fontSize: '0.9rem', fontWeight: 700, color: '#333', marginBottom: '12px' }}>
              <FaUser className='me-1' style={{ color: '#e81f29' }} /> Contact
            </h5>
            <div className='quote-detail-list'>
              <div className='quote-detail-item'>
                <FaUser className='quote-detail-icon' />
                <span>{booking.firstname} {booking.lastname}</span>
              </div>
              <div className='quote-detail-item'>
                <FaEnvelope className='quote-detail-icon' />
                <span>{booking.email}</span>
              </div>
              <div className='quote-detail-item'>
                <FaPhone className='quote-detail-icon' />
                <span>{booking.phone}</span>
              </div>
              <div className='quote-detail-item'>
                <FaMapMarkerAlt className='quote-detail-icon' />
                <span>{booking.pickUpArea}, {booking.pickUpTown}</span>
              </div>
            </div>
          </div>

          <div>
            <h5 style={{ fontSize: '0.9rem', fontWeight: 700, color: '#333', marginBottom: '12px' }}>
              <FaCar className='me-1' style={{ color: '#e81f29' }} /> Rental Info
            </h5>
            <div className='quote-detail-list'>
              <div className='quote-detail-item'>
                <strong>Vehicle:</strong>
                <span>{booking.vehicleType?.type}</span>
              </div>
              <div className='quote-detail-item'>
                <strong>Route:</strong>
                <span>
                  {booking.pickUpTown === booking.drivingToTown
                    ? `${booking.pickUpTown} (Within town)`
                    : `${booking.pickUpTown} → ${booking.drivingToTown}, ${booking.drivingToCountry}`}
                </span>
              </div>
              <div className='quote-detail-item'>
                <strong>Drop-off:</strong>
                <span>{booking.dropOffTown}</span>
              </div>
              <div className='quote-detail-item'>
                <FaCalendarAlt className='quote-detail-icon' />
                <span>{startDate} {startTime} &mdash; {endDate} {endTime} ({booking.duration} days)</span>
              </div>
              <div className='quote-detail-row'>
                <div className='quote-detail-item'>
                  <strong>Drive Mode:</strong>
                  <span>{booking.driveMode}</span>
                </div>
                <div className='quote-detail-item'>
                  <FaUserFriends className='quote-detail-icon' />
                  <span>{booking.numOfAdults} Adults, {booking.numOfChildren} Children</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Financials */}
      <div className='quote-card'>
        <h4 className='quote-card-title'><FaCreditCard /> Financial Summary</h4>
        <div className='quote-detail-list'>
          <div className='quote-detail-row'>
            <div className='quote-detail-item'>
              <strong>Driver Allowance:</strong>
              <span>{currency} {booking.totalDriverAllowance}</span>
            </div>
            <div className='quote-detail-item'>
              <strong>Booking Amount:</strong>
              <span>{currency} {booking.totalBookingAmount}</span>
            </div>
          </div>
          <div className='quote-detail-row'>
            <div className='quote-detail-item'>
              <strong>Discount:</strong>
              <span>- {currency} {booking.discount}</span>
            </div>
            <div className='quote-detail-item'>
              <strong>Final Total:</strong>
              <span style={{ fontWeight: 700, color: '#e81f29', fontSize: '1.05rem' }}>{currency} {booking.finalTotalAmount}</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
